module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeContent"
  }, [_c('div', {
    staticClass: "rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.english) ? _c('h1', {
    ref: "object1"
  }, [_vm._v("We help to let your website become "), _c('span', [_vm._v("reality")])]) : _c('h1', {
    ref: "object1"
  }, [_vm._v("Wir lassen Ihre Webseite "), _c('span', [_vm._v("Wirklichkeit")]), _vm._v(" werden")]), _vm._v(" "), (_vm.english) ? _c('div', {
    ref: "object2"
  }, [_c('p', {
    staticClass: "firstP"
  }, [_vm._v("We at LING IT love to push boundaries to create unique and innovative websites. Our goal is to connect companies with people through tailor made web experiences.")]), _vm._v(" "), _c('p', [_vm._v("We use design, creativity and cutting edge technologies to maximize engagement. Every detail matters.")])]) : _c('div', {
    ref: "object2"
  }, [_c('p', {
    staticClass: "firstP"
  }, [_vm._v("Wir bei LING IT lieben es Technologie und Design bis an die Grenzen auszureizen um kreative, einzigartige und innovative Webserfahrungen zu kreieren.")]), _vm._v(" "), _c('p', [_vm._v("Um Unternehmen ihren Kunden näher zu bringen, verwenden wir Design, Kreativität und modernste Technologien. Jedes Detail zählt.")])])]), _vm._v(" "), _c('div', {
    ref: "object3",
    staticClass: "contactData"
  }, [_c('div', {
    staticClass: "address"
  }, [(_vm.english) ? _c('h3', [_vm._v("Address")]) : _c('h3', [_vm._v("Adresse")]), _vm._v(" "), _c('p', [_vm._v("Mansfelder Straße 56")]), _vm._v(" "), _c('p', [_vm._v("06108 Halle")])]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [(_vm.english) ? _c('h3', [_vm._v("Contact")]) : _c('h3', [_vm._v("Kontakt")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    ref: "object4"
  }, [_c('div', {
    staticClass: "homeBG"
  }, [_c('svg', {
    attrs: {
      "width": "674px",
      "height": "216px",
      "viewBox": "0 0 674 216",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("HOME")]), _vm._v(" "), _c('desc', [_vm._v("Home Background")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-68.000000, -178.000000)",
      "opacity": "0.300000012"
    }
  }, [_c('path', {
    attrs: {
      "d": "M68.76,182.94 L122.7,182.94 L122.7,258.92 L155.76,258.92 L155.76,182.94 L209.7,182.94 L209.7,390 L155.76,390 L155.76,304.74 L122.7,304.74 L122.7,390 L68.76,390 L68.76,182.94 Z M284.81,286.47 C284.81,300.39007 285.003331,311.941621 285.39,321.125 C285.776669,330.308379 286.598327,337.60664 287.855,343.02 C289.111673,348.43336 290.948321,352.203323 293.365,354.33 C295.781679,356.456677 299.01998,357.52 303.08,357.52 C307.14002,357.52 310.378321,356.456677 312.795,354.33 C315.211679,352.203323 317.048327,348.43336 318.305,343.02 C319.561673,337.60664 320.383331,330.308379 320.77,321.125 C321.156669,311.941621 321.35,300.39007 321.35,286.47 C321.35,272.54993 321.156669,260.998379 320.77,251.815 C320.383331,242.631621 319.561673,235.33336 318.305,229.92 C317.048327,224.50664 315.211679,220.736677 312.795,218.61 C310.378321,216.483323 307.14002,215.42 303.08,215.42 C299.01998,215.42 295.781679,216.483323 293.365,218.61 C290.948321,220.736677 289.111673,224.50664 287.855,229.92 C286.598327,235.33336 285.776669,242.631621 285.39,251.815 C285.003331,260.998379 284.81,272.54993 284.81,286.47 Z M229.13,286.47 C229.13,267.13657 230.386654,250.655068 232.9,237.025 C235.413346,223.394932 239.569971,212.278376 245.37,203.675 C251.170029,195.071624 258.806619,188.788353 268.28,184.825 C277.753381,180.861647 289.353265,178.88 303.08,178.88 C316.806735,178.88 328.406619,180.861647 337.88,184.825 C347.353381,188.788353 354.989971,195.071624 360.79,203.675 C366.590029,212.278376 370.746654,223.394932 373.26,237.025 C375.773346,250.655068 377.03,267.13657 377.03,286.47 C377.03,305.80343 375.773346,322.284932 373.26,335.915 C370.746654,349.545068 366.590029,360.661624 360.79,369.265 C354.989971,377.868376 347.353381,384.006648 337.88,387.68 C328.406619,391.353352 316.806735,393.19 303.08,393.19 C289.353265,393.19 277.753381,391.353352 268.28,387.68 C258.806619,384.006648 251.170029,377.868376 245.37,369.265 C239.569971,360.661624 235.413346,349.545068 232.9,335.915 C230.386654,322.284932 229.13,305.80343 229.13,286.47 Z M394.43,182.94 L471.57,182.94 L493.32,305.61 L493.9,305.61 L515.65,182.94 L592.79,182.94 L592.79,390 L542.33,390 L542.33,235.72 L541.75,235.72 L513.04,390 L474.18,390 L445.47,235.72 L444.89,235.72 L444.89,390 L394.43,390 L394.43,182.94 Z M616.28,182.94 L738.95,182.94 L738.95,227.02 L670.22,227.02 L670.22,262.4 L734.6,262.4 L734.6,304.74 L670.22,304.74 L670.22,345.92 L741.56,345.92 L741.56,390 L616.28,390 L616.28,182.94 Z",
      "id": "HOME",
      "fill": "#F4F5F5"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollAnimation"
  }, [_c('svg', {
    attrs: {
      "width": "13px",
      "height": "21px",
      "viewBox": "0 0 13 21",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Scroll")]), _vm._v(" "), _c('desc', [_vm._v("Scroll Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-394.000000, -487.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "scroll",
      "transform": "translate(394.000000, 487.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.5,0.5 C3.1862915,0.5 0.5,3.1862915 0.5,6.5 L0.5,14.5 C0.5,17.8137085 3.1862915,20.5 6.5,20.5 C9.8137085,20.5 12.5,17.8137085 12.5,14.5 L12.5,6.5 C12.5,3.1862915 9.8137085,0.5 6.5,0.5 Z",
      "id": "mouse",
      "stroke": "#D0D0D0"
    }
  }), _vm._v(" "), _c('circle', {
    ref: "mouseWheel",
    attrs: {
      "id": "mouse-wheel",
      "fill": "#D0D0D0",
      "cx": "6.5",
      "cy": "8.5",
      "r": "1.5"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "mailto: info@lingit.io"
    }
  }, [_c('p', [_vm._v("info@lingit.io")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b8a5b19","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home-component.vue
// module id = 39
// module chunks = 1